<template>
  <section>
    <v-navigation-drawer
      v-model="drawer"
      app
      :style="{ background: $vuetify.theme.themes['dark'].custom_bg_menu }"
      class="sidemenu-links"
    >
      <v-img
        width="120"
        :src="$siteLogoSmall"
        class="mt-5"
        style="margin: auto;"
      ></v-img>
      <!-- <v-sheet class="banner_style pa-2">
            </v-sheet> -->

      <v-divider></v-divider>

      <v-sheet
        class="text-center mt-5"
        :style="{ background: $vuetify.theme.themes['dark'].custom_bg_menu }"
      >
        <span>Hi! {{ $store.state.currentUser.username }} <br/>
        <!-- <span style="font-size:14px">
          {{$store.state.currentUser.agent_data.level != 0 ? $store.state.currentUser.user_type == null ? $store.state.currentUser.mobilenumber : "" :"" }}
        </span> -->
        <span style="font-size:14px">{{ $store.state.currentUser.mobilenumber }}</span>
        <br/>
        <small v-html="$levelNames($store.state.currentUser.agent_data.level)"></small>
          <!--<v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                  <v-icon x-small color="primary" @click="modalUserAccount" v-bind="attrs" v-on="on">mdi-pencil</v-icon>
              </template>
              <span>Update account</span>
          </v-tooltip>-->
        </span>
        <user-account-template></user-account-template>
      </v-sheet>

      <v-divider></v-divider>

      <v-list dense nav class="mb-15">
        <v-list-item-group>
          <v-subheader>Menu</v-subheader>

          <v-list-item
            :to="{ name: 'dashboard' }"
            link
            v-if="$role.restricMenu('dashboard')"
          >
            <v-list-item-icon>
              <v-icon>mdi-view-dashboard</v-icon>
              <!-- <v-img
                src="images/g_icon_green.png"
                style="width:25px;height:25px;margin-top:-5px;background-size: contain;"
              ></v-img> -->
            </v-list-item-icon>
            <v-list-item-title>Dashboard</v-list-item-title>
          </v-list-item>

          <v-list-group
            no-action
            prepend-icon="mdi-billiards"
            :value="isDropdownMenu('draws,all_areas,prizes,all_regions')"
            v-if="
              $role.restrictDropdownMenu([
                'draws',
                'all_areas',
                'prizes',
                'all_regions',
              ])
            "
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>Draws</v-list-item-title>
              </v-list-item-content>
            </template>

            <v-list-item
              :to="{ name: 'draws' }"
              link
              v-if="$role.restricMenu('draws')"
            >
              <v-list-item-icon class="pr-2">
                <v-icon small>mdi-checkbox-blank-circle</v-icon>
              </v-list-item-icon>
              <v-list-item-title>All draws</v-list-item-title>
            </v-list-item>

            <!-- <v-list-item
              :to="{ name: 'all_regions' }"
              link
              v-if="$role.restricMenu('all_regions')"
            >
              <v-list-item-icon class="pr-2">
                <v-icon small>mdi-checkbox-blank-circle</v-icon>
              </v-list-item-icon>
              <v-list-item-title>
                <span v-if="$store.state.currentUser.agent_data.level == 0"
                  >Set by region</span
                >
                <span v-else>All regions</span>
              </v-list-item-title>
            </v-list-item> -->

            <!-- <v-list-item
              :to="{ name: 'all_areas' }"
              link
              v-if="$role.restricMenu('all_areas')"
            >
              <v-list-item-icon class="pr-2">
                <v-icon small>mdi-checkbox-blank-circle</v-icon>
              </v-list-item-icon>
              <v-list-item-title>
                <span v-if="$store.state.currentUser.agent_data.level == 0"
                  >Set by area</span
                >
                <span v-else>All areas</span>
              </v-list-item-title>
            </v-list-item> -->

            <v-list-item
              :to="{ name: 'prizes' }"
              link
              v-if="$role.restricMenu('prizes')"
            >
              <v-list-item-icon class="pr-2">
                <v-icon small>mdi-checkbox-blank-circle</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Prizes</v-list-item-title>
            </v-list-item>
          </v-list-group>

          <v-list-item
            :to="{ name: 'daily_results' }"
            link
            v-if="$role.restricMenu('daily_results')"
          >
            <v-list-item-icon>
              <v-icon>mdi-book-clock-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Daily results</v-list-item-title>
          </v-list-item>

          <v-list-item
            :to="{ name: 'winners' }"
            link
            v-if="$role.restricMenu('winners')"
          >
            <v-list-item-icon>
              <v-icon>mdi-trophy</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Winners</v-list-item-title>
          </v-list-item>

          <!-- <v-list-group no-action prepend-icon="mdi-billiards" :value="isDropdownMenu('players,online_players')"
            v-if="$role.restrictDropdownMenu(['players','online_players',])">
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>Players</v-list-item-title>
                </v-list-item-content>
              </template>
              
              <v-list-item :to="{ name: 'players' }" link v-if="$role.restricMenu('players')">
                <v-list-item-icon>
                <v-icon small>mdi-checkbox-blank-circle</v-icon>
                </v-list-item-icon>
                <v-list-item-title>All players</v-list-item-title>
              </v-list-item>

              <v-list-item :to="{ name: 'online_players' }" link v-if="$role.restricMenu('online_players')">
                <v-list-item-icon>
                <v-icon small>mdi-checkbox-blank-circle</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Online players</v-list-item-title>
              </v-list-item> 

            </v-list-group> -->

            <v-list-item :to="{ name: 'players' }" link v-if="$role.restricMenu('players')">
              <v-list-item-icon>
                <v-icon>mdi-account-supervisor-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Players</v-list-item-title>
            </v-list-item>

          <v-list-item
            :to="{ name: 'sub_agents' }"
            link
            v-if="$role.restricMenu('sub_agents')"
          >
            <v-list-item-icon>
              <v-icon>mdi-account-supervisor-circle-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title
              ><span>{{ $agentName }}s</span
            ></v-list-item-title>
          </v-list-item>

          <v-list-item
            :to="{ name: 'featured_numbers' }"
            link
            v-if="$role.restricMenu('featured_numbers')"
          >
            <v-list-item-icon>
              <v-icon>mdi-counter</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Featured numbers</v-list-item-title>
          </v-list-item>

          <v-list-item
            :to="{ name: 'bet_add' }"
            link
            v-if="$role.restricMenu('bet_add') && checkIsGMCanBet()"
          >
            <v-list-item-icon>
              <v-icon>mdi-plus</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Add bet</v-list-item-title>
          </v-list-item>

          <v-list-item
            :to="{ name: 'bet_history' }"
            link
            v-if="$role.restricMenu('bet_history')"
          >
            <v-list-item-icon>
              <v-icon>mdi-history</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Game ledger</v-list-item-title>
          </v-list-item>

          <v-list-group
            no-action
            prepend-icon="mdi-calculator-variant"
            :value="
              isDropdownMenu(
                // 'gcoins_loaded,operators_ledger,gs_by_executive,gs_by_supervisor,gs_by_manager,gs_by_player,gs_by_draw,gs_by_area,gs_by_region,commissions_ledger,win_shares,win_payouts,players_ledger,games_sales_operation,commission_released,winshare_released,payout_released,gamesharing'
                'gcoins_loaded,operators_ledger,gs_by_executive,gs_by_draw,win_shares,win_payouts,gamesharing'
              )
            "
            v-if="
              $role.restrictDropdownMenu([
                // 'gcoins_loaded',
                // 'operators_ledger',
                // 'gs_by_executive',
                // 'gs_by_manager',
                // 'gs_by_supervisor',
                // 'gs_by_player',
                // 'gs_by_draw',
                // 'gs_by_area',
                // 'gs_by_region',
                // 'commissions_ledger',
                // 'win_shares',
                // 'win_payouts',
                // 'payout_released',
                // 'players_ledger',
                // 'games_sales_operation',
                // 'commission_released',
                // 'winshare_released',
                // 'prize_fund',
                // 'agentremittance',
                // 'gamesharing',
                'gcoins_loaded',
                'operators_ledger',
                'gs_by_executive',
                'gs_by_draw',
                'win_shares',
                'win_payouts',
                'gamesharing',
              ])
            "
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>Reports</v-list-item-title>
              </v-list-item-content>
            </template>

            <v-list-item
              :to="{ name: 'gcoins_loaded' }"
              link
              v-if="$role.restricMenu('gcoins_loaded')"
            >
              <v-list-item-icon class="pr-2">
                <v-icon small>mdi-checkbox-blank-circle</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Gems loaded</v-list-item-title>
            </v-list-item>

            <v-list-item
              :to="{ name: 'operators_ledger' }"
              link
              v-if="$role.restricMenu('operators_ledger')"
            >
              <v-list-item-icon class="pr-2">
                <v-icon small>mdi-checkbox-blank-circle</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Operators ledger</v-list-item-title>
            </v-list-item>

            <!-- <v-list-item
              :to="{ name: 'managers_ledger' }"
              link
              v-if="$role.restricMenu('managers_ledger')"
            >
              <v-list-item-icon class="pr-2">
                <v-icon small>mdi-checkbox-blank-circle</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Manager ledger</v-list-item-title>
            </v-list-item> -->

            <v-list-item :to="{ name: 'gs_by_executive' }" link v-if="$role.restricMenu('gs_by_executive')">
              <v-list-item-icon class="pr-2">
                <v-icon small>mdi-checkbox-blank-circle</v-icon>
              </v-list-item-icon>
              <v-list-item-title>
                Gross sales by <span class="text-lowercase">{{ $agentName }}</span>
                </v-list-item-title>
            </v-list-item>

            <!-- <v-list-item :to="{ name: 'gs_by_manager' }" link v-if="$role.restricMenu('gs_by_manager')">
              <v-list-item-icon class="pr-2">
                <v-icon small>mdi-checkbox-blank-circle</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Gross sales by manager
                </v-list-item-title>
            </v-list-item>

            <v-list-item :to="{ name: 'gs_by_supervisor' }" link v-if="$role.restricMenu('gs_by_supervisor')">
              <v-list-item-icon class="pr-2">
                <v-icon small>mdi-checkbox-blank-circle</v-icon>
              </v-list-item-icon>
              <v-list-item-title>
                Gross sales by supervisor
                </v-list-item-title>
            </v-list-item> -->

            


            <!-- <v-list-item
              :to="{ name: 'gs_by_player' }"
              link
              v-if="$role.restricMenu('gs_by_player')"
            >
              <v-list-item-icon class="pr-2">
                <v-icon small>mdi-checkbox-blank-circle</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Gross sales by player</v-list-item-title>
            </v-list-item> -->

            <v-list-item
              :to="{ name: 'gs_by_draw' }"
              link
              v-if="$role.restricMenu('gs_by_draw')"
            >
              <v-list-item-icon class="pr-2">
                <v-icon small>mdi-checkbox-blank-circle</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Gross sales by draw</v-list-item-title>
            </v-list-item>

            <!-- <v-list-item
              :to="{ name: 'gs_by_area' }"
              link
              v-if="$role.restricMenu('gs_by_area')"
            >
              <v-list-item-icon class="pr-2">
                <v-icon small>mdi-checkbox-blank-circle</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Gross sales by area</v-list-item-title>
            </v-list-item>

            <v-list-item
              :to="{ name: 'gs_by_region' }"
              link
              v-if="$role.restricMenu('gs_by_region')"
            >
              <v-list-item-icon class="pr-2">
                <v-icon small>mdi-checkbox-blank-circle</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Gross sales by region</v-list-item-title>
            </v-list-item> -->

            

             <!-- <v-list-item :to="{ name: 'commission_released' }" link v-if="$role.restricMenu('commission_released')">
              <v-list-item-icon class="pr-2">
                <v-icon small>mdi-checkbox-blank-circle</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Commission released</v-list-item-title>
            </v-list-item> -->

            <v-list-item
              :to="{ name: 'win_shares' }"
              link
              v-if="$role.restricMenu('win_shares')"
            >
              <v-list-item-icon class="pr-2">
                <v-icon small>mdi-checkbox-blank-circle</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Win shares</v-list-item-title>
            </v-list-item>

            <!-- <v-list-item :to="{ name: 'winshare_released' }" link v-if="$role.restricMenu('winshare_released')">
              <v-list-item-icon class="pr-2">
                <v-icon small>mdi-checkbox-blank-circle</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Winshare released</v-list-item-title>
            </v-list-item> -->

            <v-list-item
              :to="{ name: 'win_payouts' }"
              link
              v-if="$role.restricMenu('win_payouts')"
            >
              <v-list-item-icon class="pr-2">
                <v-icon small>mdi-checkbox-blank-circle</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Winning payouts</v-list-item-title>
            </v-list-item>

            

            <v-list-item
              :to="{ name: 'gamesharing' }"
              link
              v-if="$role.restricMenu('gamesharing')"
            >
              <v-list-item-icon class="pr-2">
                <v-icon small>mdi-checkbox-blank-circle</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Game operation sharing</v-list-item-title>
            </v-list-item>

            <!-- <v-list-item
              :to="{ name: 'payout_released' }"
              link
              v-if="$role.restricMenu('payout_released')"
            >
              <v-list-item-icon class="pr-2">
                <v-icon small>mdi-checkbox-blank-circle</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Payouts released</v-list-item-title>
            </v-list-item> -->

            <!-- <v-list-item
              :to="{ name: 'gross_sales' }"
              link
              v-if="$role.restricMenu('gross_sales')"
            >
              <v-list-item-icon class="pr-2">
                <v-icon small>mdi-checkbox-blank-circle</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Gross sales</v-list-item-title>
            </v-list-item> -->

            <!-- <v-list-item
              :to="{ name: 'players_ledger' }"
              link
              v-if="$role.restricMenu('players_ledger')"
            >
              <v-list-item-icon class="pr-2">
                <v-icon small>mdi-checkbox-blank-circle</v-icon>
              </v-list-item-icon>
              <v-list-item-title>App players ledger</v-list-item-title>
            </v-list-item> -->
            
            <!-- <v-list-item
              :to="{ name: 'games_sales_operation' }"
              link
              v-if="$role.restricMenu('games_sales_operation')"
            >
              <v-list-item-icon class="pr-2">
                <v-icon small>mdi-checkbox-blank-circle</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Games sales operation</v-list-item-title>
            </v-list-item> -->

            <!-- <v-list-item
              :to="{ name: 'prize_fund' }"
              link
              v-if="$role.restricMenu('prize_fund')"
            >
              <v-list-item-icon class="pr-2">
                <v-icon small>mdi-checkbox-blank-circle</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Prize fund</v-list-item-title>
            </v-list-item> -->

           

            

            <!-- <v-list-item>
                            <v-list-item-icon class="pr-2">
                                <v-icon small>mdi-checkbox-blank-circle</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>Gcoins transactions</v-list-item-title>
                        </v-list-item> -->
          </v-list-group>

          <!-- <v-list-group no-action prepend-icon="mdi-format-list-bulleted" 
                        :value="isDropdownMenu('')"
                        v-if="$role.restrictDropdownMenu([])">
                        <template v-slot:activator>
                            <v-list-item-content>
                            <v-list-item-title>Banker</v-list-item-title>
                            </v-list-item-content>
                        </template>

                        <v-list-item>
                            <v-list-item-icon class="pr-2">
                                <v-icon small>mdi-checkbox-blank-circle</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>Cash-ins</v-list-item-title>
                        </v-list-item>

                        <v-list-item>
                            <v-list-item-icon class="pr-2">
                                <v-icon small>mdi-checkbox-blank-circle</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>Cash-outs</v-list-item-title>
                        </v-list-item>
                        
                        <v-list-item>
                            <v-list-item-icon class="pr-2">
                                <v-icon small>mdi-checkbox-blank-circle</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>Winning payouts</v-list-item-title>
                        </v-list-item>
                    </v-list-group> -->

                    <!-- <v-list-item
              :to="{ name: 'commissions_ledger' }"
              link
              v-if="$role.restricMenu('commissions_ledger')"
            >
              <v-list-item-icon class="pr-2">
                <v-icon small>mdi-checkbox-blank-circle</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Commissions</v-list-item-title>
            </v-list-item>
<v-list-item
              :to="{ name: 'agentremittance' }"
              link
              v-if="$role.restricMenu('agentremittance')"
            >
              <v-list-item-icon class="pr-2">
                <v-icon small>mdi-checkbox-blank-circle</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Remittance</v-list-item-title>
            </v-list-item> -->
            
          <v-list-item :to="{ name: 'commissions_ledger' }" link v-if="$role.restricMenu('commissions_ledger')">
            <v-list-item-icon>
              <v-icon>mdi-handshake-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Commissions</v-list-item-title>
          </v-list-item>

          <v-list-item :to="{ name: 'agentremittance' }" link v-if="$role.restricMenu('agentremittance')">
            <v-list-item-icon>
              <v-icon>mdi-cash</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Remittance</v-list-item-title>
          </v-list-item>

          <v-list-item :to="{ name: 'most_popular' }" link v-if="$role.restricMenu('most_popular')">
            <v-list-item-icon>
              <v-icon>mdi-seal</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Tally board</v-list-item-title>
          </v-list-item>

          <!-- <v-list-item :to="{ name: 'raffle' }" link v-if="$role.restricMenu('raffle')">
            <v-list-item-icon>
              <v-icon>mdi-ticket-confirmation</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Raffle</v-list-item-title>
          </v-list-item> -->

          <v-list-item :to="{ name: 'rewards' }" link v-if="$role.restricMenu('rewards')">
            <v-list-item-icon>
              <v-icon>mdi-trophy-award</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Rewards</v-list-item-title>
          </v-list-item>

          <!-- <v-list-item :to="{name: 'banker_management'}" link v-if="$role.restricMenu('banker_management')">
                        <v-list-item-icon>
                            <v-icon>mdi-dots-grid</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>Banker management</v-list-item-title>
                    </v-list-item> -->

          <!-- <v-list-item
            :to="{ name: 'cash_in_history' }"
            link
            v-if="$role.restricMenu('cash_in_history')"
          >
            <v-list-item-icon>
              <v-icon>mdi-cash-plus</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Cash-in request</v-list-item-title>
          </v-list-item>

          <v-list-item
            :to="{ name: 'cash_out_history' }"
            link
            v-if="$role.restricMenu('cash_out_history')"
          >
            <v-list-item-icon>
              <v-icon>mdi-account-cash</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Cash-out request</v-list-item-title>
          </v-list-item> -->

          <!-- <v-list-item
            :to="{ name: 'messages' }"
            link
            v-if="$role.restricMenu('messages')"
          >
            <v-list-item-icon>
              <v-icon>mdi-message</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Text messages</v-list-item-title>
          </v-list-item> -->

          <!-- <v-list-item
            :to="{ name: 'gcash_accounts' }"
            link
            v-if="$role.restricMenu('gcash_accounts')"
          >
            <v-list-item-icon>
              <v-icon>mdi-account-cash</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Gcash accounts</v-list-item-title>
          </v-list-item> -->

          <!-- <v-list-group
            no-action
            prepend-icon="mdi-chart-bar-stacked"
            :value="
              isDropdownMenu(
                'rep_daily_result,rep_winners,rep_manager_list,rep_operators_ledger,rep_manager_com,rep_winning_shares,rep_games_sales,rep_gcoins_summary'
              )
            "
            v-if="
              $role.restrictDropdownMenu([
                'rep_daily_result',
                'rep_winners',
                'rep_manager_list',
                'rep_operators_ledger',
                'rep_manager_com',
                'rep_winning_shares',
                'rep_games_sales',
                'rep_gcoins_summary',
              ])
            "
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>Reports</v-list-item-title>
              </v-list-item-content>
            </template>

            <v-list-item
              :to="{ name: 'rep_daily_result' }"
              link
              v-if="$role.restricMenu('rep_daily_result')"
            >
              <v-list-item-icon class="pr-2">
                <v-icon small>mdi-checkbox-blank-circle</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Daily results</v-list-item-title>
            </v-list-item>

            <v-list-item
              :to="{ name: 'rep_winners' }"
              link
              v-if="$role.restricMenu('rep_winners')"
            >
              <v-list-item-icon class="pr-2">
                <v-icon small>mdi-checkbox-blank-circle</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Winners</v-list-item-title>
            </v-list-item>

            <v-list-item
              :to="{ name: 'rep_manager_list' }"
              link
              v-if="$role.restricMenu('rep_manager_list')"
            >
              <v-list-item-icon class="pr-2">
                <v-icon small>mdi-checkbox-blank-circle</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{ $agentName }} list</v-list-item-title>
            </v-list-item>

            <v-list-item
              :to="{ name: 'rep_operators_ledger' }"
              link
              v-if="$role.restricMenu('win_shares')"
            >
              <v-list-item-icon class="pr-2">
                <v-icon small>mdi-checkbox-blank-circle</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Operators ledger</v-list-item-title>
            </v-list-item>

            <v-list-item
              :to="{ name: 'rep_manager_com' }"
              link
              v-if="$role.restricMenu('rep_manager_com')"
            >
              <v-list-item-icon class="pr-2">
                <v-icon small>mdi-checkbox-blank-circle</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{ $agentName }} commissions</v-list-item-title>
            </v-list-item>

            <v-list-item
              :to="{ name: 'rep_winning_shares' }"
              link
              v-if="$role.restricMenu('rep_winning_shares')"
            >
              <v-list-item-icon class="pr-2">
                <v-icon small>mdi-checkbox-blank-circle</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Winning shares</v-list-item-title>
            </v-list-item>

          </v-list-group> -->

          <v-list-item
            :to="{ name: 'user_management' }"
            link
            v-if="$role.restricMenu('user_management')"
          >
            <v-list-item-icon>
              <v-icon>mdi-account-group</v-icon>
            </v-list-item-icon>
            <v-list-item-title>System users</v-list-item-title>
          </v-list-item>

          <v-list-item @click="modalUserAccount">
            <v-list-item-icon>
              <v-icon>mdi-account-edit</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Account Settings</v-list-item-title>
          </v-list-item>

          <v-divider></v-divider>

          <v-list-item @click="logout" link>
            <v-list-item-icon>
              <v-icon>mdi-logout</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Logout</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>

      <v-footer
        fixed
        class="pa-2 mt-3 text-center"
        style="display: block;"
        :style="{
          background: $vuetify.theme.themes['dark'].copyright_container_bg,
        }"
      >
        <h6>
          Copyright © {{ copyrightDate }} <br />
          <!-- <a href="#">website.com</a> <br /> All rights reserved. -->
        </h6>
      </v-footer>
    </v-navigation-drawer>

    <confirm-dialog
      ref="confirm"
      class="custom-confirm-dialog"
    ></confirm-dialog>
  </section>
</template>

<script>
export default {
  data() {
    return {
      banner:
        "https://kingtech.com.ph/inventory/images/888-World-Solutions-Inc-Logo-567x267.png",
      drawer: null,
      loggeduser: {},
      copyrightDate: "",
    };
  },
  methods: {
    checkIsGMCanBet(){
      if(this.$store.state.currentUser.agent_data.canbet == 1){
          return true;
      }
      return false;
    },
    // setManagerSupervisorName() {
    //   console.log(this.$store.state.currentUser.agent_data.level);
    //   if (this.$store.state.currentUser.agent_data.level == 0) {
    //     return "Manager";
    //   } else if (this.$store.state.currentUser.agent_data.level == 1) {
    //     return "Supervisor";
    //   } else if (this.$store.state.currentUser.agent_data.level == 2) {
    //     return "Supervisor";
    //   } else {
    //     return "Manager";
    //   }
    // },
    async logout() {
      if (
        await this.$refs.confirm.open(
          "Confirm",
          "Are you sure you want to logout ?"
        )
      ) {
        this.$Fire.$emit("overlay", true);
        this.$axios
          .get(this.$_CONFIG.api("API_LOGOUT"))
          .then((data) => {
            if (data.data.message) {
              this.$Fire.$emit("overlay", false);
              this.$store.dispatch("logout");
              this.$router.push({ path: "/login" });
            }
          })
          .catch((err) => {
            this.$toast.fire({
              icon: "error",
              title: this.$_console.log(err, "Some Error"),
            });
          })
          .finally((res) => {});
      }
    },
    modalUserAccount() {
      this.$Fire.$emit("editUserAccount");
    },
    isDropdownMenu(val) {
      let current_route = this.$route.name;
      let str = val.replace(/\s/g, "");
      str = str.split(",");
      return str.includes(current_route);
    },
  },
  computed: {},
  created() {},
  watch: {},
  mounted() {
    this.$Fire.$on("sideDrawer", () => {
      this.drawer = !this.drawer;
    });

    this.$Fire.$on("logout", () => {
      this.logout();
    });

    this.copyrightDate = this.$moment().year();
  },
};
</script>